import { c as _c } from "react/compiler-runtime";
import type { ClassificationPolicy } from '@repo/api-gw-sdk';
import { Tag } from '../tag';
export const ClassificationPolicyTag = t0 => {
  const $ = _c(3);
  const {
    policy
  } = t0;
  const t1 = !policy.enabled;
  let t2;
  if ($[0] !== policy.name || $[1] !== t1) {
    t2 = <Tag icon="material-symbols-avg-pace-rounded" content={policy.name} disabled={t1} noWrap={true} />;
    $[0] = policy.name;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};